import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { OpenInNewRounded } from "@mui/icons-material";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { Box, Link, ListItemIcon, ListItemText, MenuItem } from "@mui/material";

export const purchaseCreditLanguages = {
  mainCardTitle: "Winnipeg Jets Business Passport",
  mainCardDescription:
    "A customizable spending account that allows you to utilize your tickets in a flexible way that best suits your needs.",
};

export const WinnipegJetsLink = () => (
  <Link
    href={"https://am.ticketmaster.com/tnse/"}
    target={"_blank"}
    sx={{
      color: "primary.main",
      textDecoration: "none",
      fontWeight: 500,
    }}
  >
    Account Manager
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the game you wish to purchase seats for.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Winnipeg Jets account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Winnipeg Jets <WinnipegJetsLink />{" "}
        within 24 hours of redemption. Reach out to{" "}
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="mailto:ticketsales@winnipegjets.com"
        >
          ticketsales@winnipegjets.com
        </Link>
        for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Winnipeg Jets Business Passport program work?",
    description: (
      <>
        The Winnipeg Jets Business Passport program allows fans to select any
        seat to select regular season games. Simply log into your Winnipeg Jets{" "}
        <WinnipegJetsLink /> and select games.
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "No, you can come back to use your credit throughout the season.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "After you select your games, you will be prompted to select seats from the current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly to your Winnipeg Jets{" "}
        <WinnipegJetsLink />.
      </>
    ),
  },
  {
    title: "How do I purchase more than 8 tickets to a single game?",
    description: (
      <>
        Please contact our group sales team directly at{" "}
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="mailto:groups@winnipegjets.com"
        >
          groups@winnipegjets.com
        </Link>{" "}
        or call us at{" "}
        <Link
          href="tel:2049265768"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (204) 926-5768
        </Link>{" "}
        and we will be happy to assist you.
      </>
    ),
  },
];

export function WinnipegJetsTCLanguage() {
  return (
    <>
      By purchasing you are agreeing to the Winnipeg Jets{" "}
      <Link
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="https://ss-leagues.s3.amazonaws.com/Winnipeg-Jets-Business-Passport-_BizPass_-2024-25-Terms-and-Conditions-FINAL.pdf"
        target="_blank"
      >
        Terms and Conditions
      </Link>
      .
    </>
  );
}

export function WinnipegJetsHamburgerTCListItems() {
  return (
    <Box>
      <MenuItem
        onClick={() => {
          window.open(
            "https://ss-leagues.s3.amazonaws.com/Winnipeg-Jets-Business-Passport-_BizPass_-2024-25-Terms-and-Conditions-FINAL.pdf",
            "_blank"
          );
        }}
      >
        <ListItemIcon>
          <OpenInNewRounded fontSize="small" />
        </ListItemIcon>
        <ListItemText>Winnipeg Jets Terms and Conditions</ListItemText>
      </MenuItem>
    </Box>
  );
}
